import type { AmbientKind, Layout, Phase, PresetKey, Settings, SoundKind, Typeface } from './types';

export const STORAGE_KEY = 'pomodoro.v2';
export const LEGACY_KEY = 'pomodoro.mod1';
export const BACKUP_APP_ID = 'pomodoro-focus-instrument';
export const MAX_BACKUP_BYTES = 5_000_000;

export const MINUTE = 60_000;
export const DIAL_MAX = 90; // minutes on a full turn of the dial
export const MAX_SIDE_TIMERS = 4;
export const DETAILED_LOG_DAYS = 60;
export const MAX_LOG_PER_DAY = 60;
/** A focus phase may auto-start only if the previous phase ended this recently (ms). */
export const AUTO_FOCUS_GRACE = 60_000;

export const PRESETS: Record<PresetKey, { name: string; focus: number; short: number; long: number }> = {
  classic: { name: 'Classic', focus: 25, short: 5, long: 15 },
  steady: { name: 'Steady', focus: 45, short: 15, long: 30 },
  deep: { name: 'Deep', focus: 50, short: 10, long: 30 },
  ultradian: { name: 'Ultradian', focus: 90, short: 20, long: 30 },
};

export const PHASE_LABEL: Record<Phase, string> = {
  focus: 'FOCUS',
  short: 'SHORT BREAK',
  long: 'LONG BREAK',
};
export const PHASE_VAR: Record<Phase, string> = { focus: '--tomato', short: '--sage', long: '--pine' };

export const SOUNDS: readonly SoundKind[] = ['bell', 'marimba', 'wood', 'bell2', 'marimba2', 'wood2'];
export const AMBIENTS: readonly AmbientKind[] = ['off', 'brown', 'pink', 'rain'];
export const LAYOUTS: readonly Layout[] = ['minimal', 'desk', 'logbook', 'horizon', 'flip', 'strip'];
export const TYPEFACES: readonly Typeface[] = [
  'instrument',
  'hyperlegible',
  'grotesk',
  'lexend',
  'editorial',
  'system',
];
/** Snap points for the text-size slider (percent). */
export const TEXT_SCALE_STEP = 5;

export const CLAMPS = {
  focus: [1, DIAL_MAX],
  short: [1, 30],
  long: [1, 45],
  interval: [2, 8],
  volume: [0, 100],
  ambientVolume: [0, 100],
  dailyGoal: [0, 24],
  est: [1, 12],
  textScale: [85, 150],
} as const satisfies Record<string, readonly [number, number]>;

export const DEFAULT_SETTINGS: Settings = {
  focus: 25,
  short: 5,
  long: 15,
  interval: 4,
  autoBreak: true,
  autoFocus: false,
  sound: 'bell',
  volume: 70,
  ticking: false,
  theme: 'light',
  dailyGoal: 8,
  ambient: 'off',
  ambientVolume: 40,
  wakeLock: false,
  layout: 'minimal',
  typeface: 'instrument',
  textScale: 100,
};
